<template>
  <div v-if="senderType === 'USER'" class="fs-14">
    {{text}}
  </div>
  <div v-else class="template-edit-area">
    <!-- TODO 추후 템플릿 타입명 정의에 따라 변경해서 맞출것. -->

    <!-- 텍스트 -->
    <scenario-template-text v-if="subType === 'TEXT'"
                            :brandKey="brandKey" :chatRoomId="chatRoomId"
                            :title="title"
                            :description="description"
                            :buttons="buttons" :preview="preview">
    </scenario-template-text>

    <!-- 이미지 -->
    <scenario-template-image v-else-if="subType === 'IMAGE'"
                             :brandKey="brandKey" :chatRoomId="chatRoomId"
                             :url="url"
                             :buttons="buttons" :preview="preview">
    </scenario-template-image>

    <!-- 리스트 -->
    <scenario-template-lists v-else-if="subType === 'LIST'"
                             :brandKey="brandKey" :chatRoomId="chatRoomId"
                             :lists="lists"
                             :buttons="buttons" :preview="preview">
    </scenario-template-lists>

    <!-- 이미지 + 텍스트 -->
    <scenario-template-image-text v-else-if="subType === 'IMAGE_TEXT'"
                                  :brandKey="brandKey" :chatRoomId="chatRoomId"
                                  :url="url"
                                  :title="title"
                                  :description="description"
                                  :buttons="buttons" :preview="preview">
    </scenario-template-image-text>

    <!-- 이미지 + 리스트 -->
    <scenario-template-image-lists v-else-if="subType === 'IMAGE_LIST'"
                                   :brandKey="brandKey" :chatRoomId="chatRoomId"
                                   :url="url"
                                   :lists="lists"
                                   :buttons="buttons" :preview="preview">
    </scenario-template-image-lists>

    <!-- 이미지 + 리스트 + 텍스트 -->
    <scenario-template-image-lists-text v-else-if="subType === 'IMAGE_LIST_TEXT'"
                                        :brandKey="brandKey" :chatRoomId="chatRoomId"
                                        :url="url"
                                        :lists="lists"
                                        :title="title"
                                        :description="description"
                                        :buttons="buttons" :preview="preview">
    </scenario-template-image-lists-text>

    <!-- 리스트 + 텍스트 -->
    <scenario-template-lists-text v-else-if="subType === 'LIST_TEXT'"
                                  :brandKey="brandKey" :chatRoomId="chatRoomId"
                                  :lists="lists"
                                  :title="title"
                                  :description="description"
                                  :buttons="buttons" :preview="preview">
    </scenario-template-lists-text>

    <div v-else style="margin: 10px"> [未定義のタイプです。] </div>
  </div>
</template>

<script>
import scenarioTemplateText from './scenario/templates/scenario_template_text'
import scenarioTemplateImage from './scenario/templates/scenario_template_image'
import scenarioTemplateLists from './scenario/templates/scenario_template_lists'
import scenarioTemplateImageText from './scenario/templates/scenario_template_image_text'
import scenarioTemplateImageLists from './scenario/templates/scenario_template_image_lists'
import scenarioTemplateImageListsText from './scenario/templates/scenario_template_image_lists_text'
import scenarioTemplateListsText from './scenario/templates/scenario_template_lists_text'

export default {
  name: 'message_scenario',
  components: {
    scenarioTemplateText,
    scenarioTemplateImage,
    scenarioTemplateLists,
    scenarioTemplateImageText,
    scenarioTemplateImageLists,
    scenarioTemplateImageListsText,
    scenarioTemplateListsText
  },
  props: [
    'brandKey', 'chatRoomId', 'senderType', 'content', 'gnb', 'preview'
  ],
  data () {
    return {
      subType: '',
      text: '',
      url: '',
      title: '',
      description: '',
      buttons: [],
      lists: []
    }
  },
  created () {
    let jsonContent = JSON.parse(this.content)

    this.subType = jsonContent.subType
    this.url = jsonContent.url
    this.text = jsonContent.text
    this.title = jsonContent.title
    this.description = jsonContent.description
    this.lists = jsonContent.lists
    this.buttons = jsonContent.buttons
  }
}
</script>

<style scoped>
  .template-edit-area {
    width: 310px;
    max-width: 310px;
    background-color: white;
    border-radius: 15px;
    padding: 0 0 10px 0;
    position: relative;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/message_scenario.vue